import { BackdropLoader, Icon, InputWithIcon } from '@livable/saas-react-components';
import { Box, Container, Typography, Link, LinearProgress, Paper, Grid, TextField } from '@mui/material';
import React from 'react';
import useStyles from '../styles';
const progressBarExample = "\nimport LinearProgress from '@mui/material';\n\n<LinearProgress />\n";
const blockBackdropLoaderExample = "\nimport { BackdropLoader } from '@livable/saas-react-components';\n\n<BackdropLoader isOpen={true} />\n";
export default function LvLoaders() {
  const classes = useStyles();
  const icons = ['loader', 'loader-line'];
  const getIcon = (icon, i) => /*#__PURE__*/React.createElement("div", {
    className: classes.flexCenter,
    key: i
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "large",
    isSpinning: true,
    pattern: "gradient",
    type: icon
  }), /*#__PURE__*/React.createElement("pre", {
    className: "".concat(classes.codeSnippet, " ").concat(classes.codeSnippetInline)
  }, /*#__PURE__*/React.createElement("code", null, "<Icon fontSize=\"large\" isSpinning pattern=\"gradient\" type=\"".concat(icon, "\" />"))));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: classes.section
  }, /*#__PURE__*/React.createElement("span", null, "Loaders ")), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Loader icon"), /*#__PURE__*/React.createElement("div", {
    className: classes.iconsWrapper
  }, icons.map((icon, i) => getIcon(icon, i))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement("span", null, "Progress bar "), /*#__PURE__*/React.createElement(Link, {
    href: "https://mui.com/material-ui/react-progress/#linear-determinate",
    target: "_blank"
  }, "(documentation)")), /*#__PURE__*/React.createElement(LinearProgress, null), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, progressBarExample), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement("span", null, "Block backdrop loader "), /*#__PURE__*/React.createElement(Link, {
    href: "https://mui.com/material-ui/react-backdrop/",
    target: "_blank"
  }, "(documentation)")), /*#__PURE__*/React.createElement(Paper, {
    variant: "formWrapper"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, "Property information"), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Property square footage"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p",
    className: classes.xsSection
  }, "Square footage is required for utility corresponding allocation methods. It is also required to properly set Common Area Deduction (CAD), which values will rely on the property square footage."), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "building"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Square ft.",
    variant: "outlined",
    fullWidth: true,
    type: "number",
    id: "buildingSquare",
    name: "buildingSquare"
  })))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: true
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, blockBackdropLoaderExample))));
}